import { render, staticRenderFns } from "./Pagetion.vue?vue&type=template&id=70cc3f5c&scoped=true"
import script from "./Pagetion.vue?vue&type=script&lang=js"
export * from "./Pagetion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc3f5c",
  null
  
)

export default component.exports